import { render } from "./stocktransferlist.vue?vue&type=template&id=7f4a232a&scoped=true"
import script from "./stocktransferlist.vue?vue&type=script&lang=js"
export * from "./stocktransferlist.vue?vue&type=script&lang=js"

import "./stocktransferlist.vue?vue&type=style&index=0&id=7f4a232a&scoped=true&lang=css"
import "./stocktransferlist.vue?vue&type=style&index=1&id=7f4a232a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4a232a"]])

export default __exports__